module.exports = __webpack_public_path__ + "static/algorithms-e51befadaaa1599c1e815e29d00381ac.jpg";